import React from "react";
import { toast } from "react-toastify";
import Layout4 from "../../components/Layout/Layout4";
import Loading from "../../components/Loading";
import Table from "../../components/Table";
import { completeOrder, getTradingStaffOrder } from "../../utils/api";
import { formatDate } from "../../utils/formatData";
import useStore from "../../utils/store";

const TradingStaff = () => {
  const [dash, setDash] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const getData = async () => {
    setLoading(true);
    const [success, data] = await getTradingStaffOrder();
    if (success) {
      setDash(data);
    }
    setLoading(false);
  };
  const user = useStore((state) => state.user);
  React.useEffect(() => {
    getData();
  }, []);
  return (
    <Layout4 type={"TradingStaff"} title={user?.staff?.userName}>
      {loading && <Loading />}
      <Table
        type={"TradingStaff"}
        data={dash}
        columns={[
          {
            title: "Date",
            render: (row) => formatDate(row?.createdAt),
          },

          {
            title: "description",
            render: (row) => row.description,
          },
          {
            title: "FSSAI",
            render: (record) => record?.customer?.fssai,
          },
          {
            title: "Agency",
            render: (record) => record?.customer?.agency,
          },

          {
            title: "Items",
            render: (row) => row.product.productName,
          },
          {
            title: "Qnt.",
            render: (row) => row.quantity,
          },
          {
            title: "Customer",
            render: (row) => row.customer.userName,
          },
          {
            title: "Location",
            render: (record) => record?.customer?.group?.name,
          },
          {
            title: "PDF",
            render: (row) => (
              <button
                className="bg-green-500  px-2 py-1 "
                onClick={async () => {
                  setLoading(true);
                  const [success, data] = await completeOrder(row._id, {
                    type: "staff",
                    completedById: user.staff._id,
                  });
                  if (success) {
                    toast.success("Order Completed");
                    getData();
                  } else {
                    toast.error(data);
                  }
                  setLoading(false);
                }}
              >
                Complete
              </button>
            ),
          },
        ]}
      />
    </Layout4>
  );
};

export default TradingStaff;
